/** Public marketing site SEO defaults (manage360.me). */
export const SITE_URL = "https://www.manage360.me";
export const SITE_NAME = "Manage360";
export const SITE_TAGLINE =
  "Your personal AI assistant for a seamless everyday life";

export const DEFAULT_DESCRIPTION =
  "Manage360 combines Screen AI, Media AI, Audio AI, Video AI, Transfer AI, Portfolio AI, Project AI, Todos AI, Daily Chore AI, notes, calendar, files, and group bills in one free dashboard. Optional AI Usage Credits for smart capture and voice.";

export const DEFAULT_KEYWORDS = [
  "personal AI assistant",
  "life admin app",
  "productivity dashboard",
  "Screen AI",
  "lecture capture AI",
  "meeting notes from screen",
  "Media AI",
  "summarize slides and video",
  "Audio AI",
  "voice note transcription",
  "Video AI",
  "video timeline analysis",
  "ask questions about video",
  "Transfer AI",
  "traveller matching board",
  "expense tracker India",
  "voice expense tracking",
  "project management app",
  "Kanban voice commands",
  "todo list app",
  "daily chore reminders",
  "recurring tasks calendar",
  "split bills app",
  "Splitwise alternative",
  "student study tools",
  "work from home organization",
  "Manage360",
  "Manage360.me",
].join(", ");

export const OG_IMAGE = `${SITE_URL}/logo.png`;

export const PUBLIC_PATHS = [
  "/",
  "/pricing",
  "/blog",
  "/faqs",
  "/contact-us",
  "/templates",
  "/success-stories",
  "/terms-and-conditions",
  "/privacy-policy",
  "/login",
  "/register",
];
